// extracted by mini-css-extract-plugin
export var infoItem = "_rv-2";
export var title = "_rv-0";
export var value = "_rv-1";